import {
  AUTO_JOIN_MODE_VALUES,
  ORGANISATION_KIND_VALUES,
  ORGANISATION_STATUS_VALUES,
  type AutoJoinMode,
  type OrganisationKind,
  type OrganisationStatus,
} from "@sagot/constants";

export const ORGANISATION_PAGE_SIZE = 25;
export const ORGANISATION_RECENT_TICKETS = 5;
export const ORGANISATION_ACTIVITY_LIMIT = 10;
export const ORGANISATION_SEARCH_DEBOUNCE_MS = 300;

/** The server's display-code rule (`ORGANISATION_DISPLAY_CODE_PATTERN`). */
export const ORGANISATION_CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_.-]*$/;
/** A plain host name such as `example.com.ph`: labels of letters, digits and dashes, at least two of them. */
export const DOMAIN_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;
/** Letters of the name used for the tile when the organisation has no code. */
export const ORGANISATION_TILE_LETTERS = 3;

export const ORGANISATION_TABS = ["overview", "contacts", "tickets", "assets", "contracts", "visits", "projects", "orders", "activity"] as const;
export type OrganisationTab = (typeof ORGANISATION_TABS)[number];

/** The Service settings tab the import wizard (SD-S1-50) will open on. */
export const IMPORT_WIZARD_TAB = "import";

export const KIND_OPTIONS: readonly OrganisationKind[] = ORGANISATION_KIND_VALUES;
export const STATUS_OPTIONS: readonly OrganisationStatus[] = ORGANISATION_STATUS_VALUES;
export const AUTO_JOIN_OPTIONS: readonly AutoJoinMode[] = AUTO_JOIN_MODE_VALUES;

/** Backend error codes this feature maps to field messages (`app/core/errors.py`); the shared list lags the backend. */
export const DOMAIN_IN_USE_CODE = "domain_in_use";
export const ORGANISATION_EXISTS_CODE = "organisation_exists";
export const PUBLIC_DOMAIN_CODE = "public_domain";

export function isOrganisationTab(value: string | undefined): value is OrganisationTab {
  return ORGANISATION_TABS.some((tab) => tab === value);
}
